import { Component, Input, forwardRef } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BbSelectOption } from '../bb-select/bb-select.component';

@Component({
	selector: 'bb-time',
	templateUrl: './bb-time.component.html',
	styleUrls: ['./bb-time.component.scss'],
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		useExisting: forwardRef(() => BbTimeComponent),
		multi: true
	}]
})

export class BbTimeComponent implements ControlValueAccessor {
	@Input() useDate = false;
	@Input() theme? = 'embargo';

	timeInput: string;
	showDropdown: boolean;
	searchTerm: Subject<KeyboardEvent>;
	times: BbSelectOption[];

	private date = null;
	private options: BbSelectOption[];

	constructor() {
		this.options = new Array<BbSelectOption>();

		for (let hour = 0; hour < 24; hour++) {
			[':00', ':30'].forEach((minutes) => {
				if (hour < 10) {
					this.options.push({ label: '0' + hour + minutes, value: hour + minutes });
				} else {
					this.options.push({ label: hour + minutes, value: hour + minutes });
				}
			});
		}
		this.times = this.options;
		this.searchTerm = new Subject<KeyboardEvent>();
		this.timeInput = '';
		this.showDropdown = false;

		this.searchTerm.subscribe((keyboardEvent: KeyboardEvent) => {
			// console.log('got key', keyboardEvent.key, keyboardEvent.keyCode, keyboardEvent.code);
			if (keyboardEvent.key === 'Enter') {
				this.showDropdown = false;
				this.propagate();
			} else {
				if (isNaN(parseInt(keyboardEvent.key, 10)) && keyboardEvent.key !== ':') {
					switch (keyboardEvent.code) {
						case 'Backspace':
							if (this.timeInput.length === 3) {
								this.timeInput = this.timeInput.split(':')[0];
							}
							this.times = this.options.filter((option: BbSelectOption) => option.label.search(this.timeInput.slice(0, -1)) > -1);
							break;
						default:
							if ('Delete ArrowUp ArrowDown ArrowRight ArrowLeft SemiColon Tab'.split(' ').indexOf(keyboardEvent.key) === -1) {
								keyboardEvent.preventDefault();
							}
					}
				} else {
					if (this.timeInput.length < 5) {
						if ((this.timeInput.length === 2 && keyboardEvent.key !== ':') ||
							(this.timeInput.length !== 2 && keyboardEvent.key === ':')) {
							keyboardEvent.preventDefault();
						}
					} else {
						keyboardEvent.preventDefault();
					}
				}
			}
		});

		this.searchTerm.pipe(
			debounceTime(500),
			distinctUntilChanged()
		).subscribe((t: any) => {
			if (this.searchTerm) {
				let value = '';
				if (t.target && t.target.value) {
					value = t.target.value;
					this.times = this.options.filter((option: BbSelectOption) => option.label.search(value) > -1);
					this.showDropdown = this.times.length > 0;
				}
			}
		});
	}

	selectTime(option: BbSelectOption) {
		this.showDropdown = false;
		this.times = this.options;
		this.timeInput = option.label;
		this.propagate();
	}

	timeInputChanged() {
		this.propagate();
	}

	propagate() {
		if (this.useDate) {
			this.date = new Date(this.date.setHours(Number(this.timeInput.split(':')[0]), Number(this.timeInput.split(':')[1]), 0, 0));
			this.propagateChange(this.date);
		} else {
			this.propagateChange(this.timeInput);
		}
	}

	writeValue(value: string | Date) {
		if (this.useDate && value) {
			this.date = value as Date;
			this.timeInput = (this.date.getHours() < 10 ? '0' : '') + this.date.getHours() + ':'
				+ (this.date.getMinutes() < 10 ? '0' : '') + this.date.getMinutes();
		} else {
			this.timeInput = value as string;
		}
	}

	propagateChange = (_: any) => { };

	registerOnChange(fn: any) {
		this.propagateChange = fn;
	}

	registerOnTouched() {
	}
}
